import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatError, setUnauthorizedHandler, setAuthToken, clearAuthToken } from "@/lib/api";
import { toast } from "sonner";

const AuthContext = createContext(null);

// Capture ?ref=CODE from any landing URL so it survives the signup flow.
if (typeof window !== "undefined") {
  const ref = new URLSearchParams(window.location.search).get("ref");
  if (ref) localStorage.setItem("rawaj_ref", ref.toUpperCase());
}
const claimReferral = async () => {
  const code = localStorage.getItem("rawaj_ref");
  if (!code) return;
  try { await api.post("/referral/claim", { code }); } catch (e) {}
  localStorage.removeItem("rawaj_ref");
};
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=user

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(null));
    const hash = typeof window !== "undefined" ? window.location.hash || "" : "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      const consent = localStorage.getItem("rawaj_consent") === "1";  // أقرّ في صفحة التسجيل: 18+ والموافقة على الشروط
      api
        .post("/auth/google/session", { session_id: sid, over_18: consent, accepted_terms: consent })
        .then((r) => {
          localStorage.removeItem("rawaj_consent");
          const { access_token, refresh_token, ...u } = r.data;
          setAuthToken(access_token, refresh_token);
          setUser(u);
          claimReferral();
          if (u.role === "admin") window.location.replace("/app/admin-overview");
          else {
            window.history.replaceState(null, "", window.location.pathname + window.location.search);
            if (u.is_new) toast.success("تم إنشاء حسابك وتفعيل هدية الترحيب 🎁 صورتان + فيديو + 25 ريال رصيد", { duration: 8000 });
          }
        })
        .catch((e) => { setUser(null); const d = e?.response?.data?.detail; api.post("/public/track", { event: "register_error", sid: localStorage.getItem("rawaj_sid") || "", err: e?.response?.status ? "google_session" : "network", provider: "google" }).catch(() => {}); if (typeof d === "string") { sessionStorage.setItem("rawaj_auth_error", d); window.location.replace("/register?err=consent"); } });
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    const { access_token, refresh_token, ...u } = data;
    setAuthToken(access_token, refresh_token);
    setUser(u);
    return u;
  };

  const register = async (name, email, password, phone, consent = {}) => {
    const { data } = await api.post("/auth/register", { name, email, password, phone, sid: localStorage.getItem("rawaj_sid") || "", ...consent });
    const { access_token, refresh_token, ...u } = data;
    setAuthToken(access_token, refresh_token);
    setUser(u);
    await claimReferral();
    return u;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    clearAuthToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, formatError }}>
      {children}
    </AuthContext.Provider>
  );
}
